export default "__VITE_ASSET__2f8df2f7__"